function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#231F20",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.482 3.518a11.986 11.986 0 00-16.964 0 11.986 11.986 0 000 16.964 11.986 11.986 0 0016.964 0 11.986 11.986 0 000-16.964zM12 18.686a6.686 6.686 0 110-13.373 6.686 6.686 0 010 13.373zm3.293-16.765l-1.098 1.996c-.698-.2-1.496-.3-2.195-.3-.798 0-1.497.1-2.195.3L8.707 1.92c2.195-.699 4.49-.699 6.586 0zM1.921 15.293c-.699-2.095-.699-4.39 0-6.586l1.996 1.098c-.2.698-.3 1.397-.3 2.195 0 .798.1 1.497.3 2.195L1.92 15.293zm6.786 6.786l1.098-1.996c.698.2 1.397.3 2.195.3.798 0 1.497-.1 2.195-.3l1.098 1.996c-2.095.699-4.39.699-6.586 0zm11.476-7.884c.2-.698.3-1.496.3-2.195 0-.798-.1-1.497-.3-2.195l1.996-1.098c.698 2.095.698 4.39 0 6.586l-1.996-1.098z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.6 10.3c-.7 0-1.3.4-1.5 1-.3-.6-.9-1-1.5-1-.9 0-1.7.8-1.7 1.7 0 2.6 3.2 4 3.2 4s3.2-1.4 3.2-4c0-1-.7-1.7-1.7-1.7z"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;